(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["social-feed"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function() {

	const slider = document.querySelector(".social-feed-scroll");
    let isDown = false;
    let startX;
    let scrollLeft;
    let timeOutHandle;
    let justScrolled = false;

    slider.addEventListener("mousedown", e => {
	  e.preventDefault(); 
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.classList.remove("active");
    });
    slider.addEventListener("mouseup", e => {
      e.preventDefault();
      isDown = false;
      slider.classList.remove("active");
    });
    slider.addEventListener("mousemove", e => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = x - startX;
      slider.scrollLeft = scrollLeft - walk;
      justScrolled = true;
      if (timeOutHandle) clearTimeout(timeOutHandle);
      timeOutHandle = setTimeout(function() { justScrolled = false; },250); 
    });

    document.querySelectorAll(".social-feed-scroll a").forEach(anchor => {
		anchor.addEventListener("click", e => {
			if (justScrolled) e.preventDefault();   
		});
	});
	
});


  } catch(e) { console.error(e); }
})();
})();
